import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-footer text-white mt-0" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-43">
          {/* Services */}
          <div data-id="element-44">
            <h3 className="text-lg font-bold mb-4 text-white" data-id="element-45">Services</h3>
            <ul className="space-y-2" data-id="element-46">
              <li data-id="element-47">
                <Link to="/services/web-development" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-48">
                  Custom Web Development
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/services/mobile-apps" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-50">
                  Mobile Applications
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/ai-automation" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-52">
                  AI & Automation
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/services/database-solutions" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-54">
                  Database Solutions
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/services/high-availability" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-56">
                  High Availability
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-57">
            <h3 className="text-lg font-bold mb-4 text-white" data-id="element-58">Company</h3>
            <ul className="space-y-2" data-id="element-59">
              <li data-id="element-60">
                <Link to="/about" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-61">
                  About
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/contact" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-63">
                  Contact
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/support" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-65">
                  Project Support
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/privacy-policy" className="text-blue-200 hover:text-accent transition-colors text-sm" data-id="element-67">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-68">
            <h3 className="text-lg font-bold mb-4 text-white" data-id="element-69">Contact</h3>
            <div className="space-y-2 text-blue-200 text-sm" data-id="element-70">
              <p className="text-white font-medium" data-id="element-71">Magnus Software</p>
              <p data-id="element-72">Custom Software Development</p>
              <p className="mt-4" data-id="element-73">
                <a href="tel:231-266-0606" className="text-gold hover:text-yellow-400 font-semibold transition-colors" data-id="element-74">
                  231-266-0606
                </a>
              </p>
              <p className="text-blue-300 text-xs mt-2" data-id="element-75">
                New projects by referral only
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-divider mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-blue-300 text-sm" data-id="element-76">
          <p data-id="element-77">
            &copy; {new Date().getFullYear()} Magnus Software. All rights
            reserved.
          </p>
          <Link to="/privacy-policy" className="text-blue-300 hover:text-accent transition-colors text-sm" data-id="element-78">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>;
}